import { createClient } from '@supabase/supabase-js';

// Supabase client for frontend (uses anon/publishable key)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Debug logging (remove in production)
if (process.env.NODE_ENV === 'development') {
}

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️  Supabase environment variables not set.');
  console.warn('   Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY');
  console.warn('   Make sure .env file exists in the client directory');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

